const Minus = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <rect x="8" y="15" width="16" height="2" />
  </svg>
)

export default Minus
